// extracted by mini-css-extract-plugin
module.exports = {"position":"position--39Rdw","isOpen":"isOpen--4LWI6","sidebarImg":"sidebarImg--kJIOP"};